import { get } from 'lodash-es';

import authRequest from 'src/utils/fetch';

import urls from '../../../urls';

type CommitFile = {
  path: string;
  content: string | null | undefined;
};

export type CommitPayload = {
  branch: string;
  files: CommitFile[];
  message: string;
  parents: [string | null | undefined];
  repository: {
    full_name: string;
  };
  transient: boolean;
};

export async function commitChange(
  repoName: string,
  commitPayload: CommitPayload
) {
  const [owner, slug] = repoName.split('/');
  const response = await fetch(
    authRequest(urls.api.internal.onlineEditorCommit(owner, slug), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(commitPayload),
    })
  );
  const content = await response.text();
  if (!response.ok) {
    let errorObj = null;
    try {
      errorObj = JSON.parse(content);
    } catch {
      throw new Error(content);
    }

    // TS fix: This needs cleaning up to be idiomatic but
    // doing minimum change to miminize risk.
    const message = get(errorObj, 'error.message');
    if (message) {
      throw new Error(message);
    }
    throw new Error(content);
  }

  return JSON.parse(content);
}
